import { fetch } from '@atlassian/eoc-fetch';

import { type RoutingRulesResponse } from '../../common/types';

export const getRoutingRules = (teamId: string): Promise<RoutingRulesResponse> =>
	fetch<RoutingRulesResponse>(`/v1/teams/${teamId}/routing-rules`);
